import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  makeGetRequest,
  makePostRequest,
  GET_PROFILE_PAGE_DATA,
  getRowFieldsDataSelector,
} from '@ibibo/myaccount-reducer';
import * as S from './Agreement.styles';
import CheckBox from '../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/CheckBox/CheckBox';
import CTA from '../CTA/CTA';

const Agreement = ({agreementData, changeModalType}) => {
  const dispatch = useDispatch();
  const rowFieldsData = useSelector(getRowFieldsDataSelector);
  const {
    data: {primaryText, agreementDoc, ctas},
  } = agreementData || {};
  const [ctaDisableArray, setCtaDisableArray] = useState([]);

  const [isChecked, setIsChecked] = useState(false);
  const [loader, setLoader] = useState(false);

  const onClickCB = data => {
    const {body, url} = data;
    for (const i in body) {
      body[i] = rowFieldsData[i];
    }
    if (url) {
      dispatch(makePostRequest(url, body, successCallback, errorCallback));
      setLoader(true);
    }
  };

  const successCallback = resp => {
    setLoader(false);
    changeModalType && changeModalType('VERIFICATION_MODAL', resp);
  };

  const errorCallback = err => {
    setLoader(false);
    //console.log(err);
  };

  const getDisableStatus = data => {
    const body = (data?.action?.api || {}).body;

    if (body && Object.keys(body)?.length) {
      for (const i in body) {
        if (!rowFieldsData[i]) {
          return false;
        }
      }
    }
    return true;
  };

  const handleCheckboxChange = () => {
    setIsChecked(isChecked => !isChecked);
  };

  return (
    <S.Wrapper>
      <div className="">
        {/*
         ==CAN BE REQUIRED LATER==
         <p className="appendBottom20">
        <span className="miniChevronIcon Left blackIcon"></span>
        <span className="font12 lineHeight18 latoBold appendLeft8">Back</span>
      </p> */}

        <div dangerouslySetInnerHTML={{__html: agreementDoc}} />
        <div className="makeFlex appendTop20">
          <CheckBox id={`agrMdl_`} onChange={handleCheckboxChange}>
            <p className="font14 appendLeft10">I have read and agree to the Terms and Conditions</p>
          </CheckBox>
        </div>
        {ctas?.length &&
          ctas.map(({component, data}, idx) => {
            return (
              <CTA
                onClickCB={onClickCB}
                component={component}
                data={data}
                style={data?.styles}
                isActive={getDisableStatus(data) && isChecked && !loader}
                //closeModal={handleCloseModalSubForm}
              />
            );
          })}
      </div>
    </S.Wrapper>
  );
};

export default Agreement;
